export const content = {
    marginTop: '0.5em',
};

export const dialogLayout = {
    height   : 'auto',
    width    : '30em',
    maxHeight: '80vh',
    resizable: false,
};

export const error = {
    color   : 'red',
    fontSize: '0.8em',
};

export const errorDiv = {
    color   : 'black',
    maxWidth: 'calc(90vw - 45%)',
};

export const linkButton = {
    fontWeight    : '500',
    fontSize      : '23px',
    minWidth      : '140px',
    height        : '40px',
    borderWidth   : '2px',
    background    : 'green',
    color         : 'white',
    padding       : '0 16px',
    display       : 'inline-flex',
    borderRadius  : '4px',
    transition    : 'all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1)',
    outline       : '0',
    position      : 'relative',
    textDecoration: 'none',
    verticalAlign : 'middle',
    alignItems    : 'center',
    justifyContent: 'center',
};

export const linkButtonWrapper = {
    display       : 'flex',
    justifyContent: 'center',
};

export const errorMessage = {
    fontSize     : '25px',
    color        : 'black',
    fontWeight   : '400',
    textTransform: 'none',
    lineHeight   : '1.5',
    margin       : '0 0 24px',
    textAlign    : 'center',
};

export const errorMessageWrapper = {
    display       : 'flex',
    justifyContent: 'center',
};

export const errorHeader = {
    fontSize  : '29px',
    color     : '#e98024',
    fontWeight: 'bold',
    textAlign : 'center',
};

export const submitButton = {
    textAlign: 'center',
};

export const input = {
    position: 'absolute',
    right   : '0.5em',
    width   : '4em',
};

export const filename = {
    width : '12em',
    margin: '0em 0em 0em 4.8em',
};

export const inputRow = {
    marginBottom: '0.5em',
};

export const field = {
    width: '18em',
};

export const checkbox = {
    margin: '0em 0em 0em 0.5em',
};

export const loading = {
    textAlign : 'center',
    paddingTop: '50%',
    fontSize  : '1.5em',
};

export const iframe = { width: '100%', height: '100%' };

export const exportButton = {
    position: 'absolute',
    left    : '41em',
    zIndex  : 2,
    padding : 0,
    width   : '2em',
    height  : '2em',
};

export const tradeTableExport = { marginTop: '-2.5em' };

export const bottomWarning = {
    bottom    : '0px',
    position  : 'fixed',
    zIndex    : 9999,
    background: '#c03',
    color     : 'white',
    width     : '100%',
    textAlign : 'center',
    lineHeight: '25px',
    fontSize  : '0.8em',
};

export const bottomWarningLink = { textDecoration: 'underline' };

export const green = { color: 'green' };

export const greenLeft = { color: 'green', float: 'left' };

export const red = { color: 'red' };

export const redLeft = { color: 'red', float: 'left' };

export const blueLeft = { color: '#42A5F5', float: 'left' };

export const whiteLeft = { color: '#ccc', float: 'left' };

export const tradePanelAccount = { float: 'right' };

export const left = { float: 'left' };

export const warningText = {
    'font-size': '12px',
    color      : 'lightgray',
};



// WEBPACK FOOTER //
// ./src/botPage/view/style.js